import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth';
import { ErrorBoundary } from './components/ErrorBoundary';
import { installGlobalErrorHandlers } from './diagnostics';
import { I18nProvider } from './i18n';
import { ThemeProvider } from './theme';
import './index.css';

// Capture des erreurs globales (exceptions + rejets non gérés) AVANT tout rendu :
// la cause d'un crash précoce est ainsi présente dans l'anneau de diagnostic.
installGlobalErrorHandlers();

const root = document.getElementById('root');
if (!root) throw new Error('Élément #root introuvable');

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <I18nProvider>
        <ErrorBoundary>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </ErrorBoundary>
      </I18nProvider>
    </ThemeProvider>
  </StrictMode>,
);
